import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

export const isWorkItemModernizationGatesEnabled = (): boolean => {
	return (
		expVal('work_item_modernization', 'isEnabled', false) ||
		fg('enable_work_item_for_quadratic_release')
	);
};
